
import { ajax } from "@/assets/js/ajax";

export function sessions() {
  //账户列表
  return ajax({
    url: "chat/sessions",
    type: "get"
  });
}
export function get_session(data) {
  //账户列表
  return ajax({
    url: "chat/get_session",
    type: "post",
    data
  });
}
export function havemsg(data) {
  //账户列表
  return ajax({
    url: "chat/messages",
    type: "get",
    data
  });
}

export function havetoken(data) {
  //账户列表
  return ajax({
    url: "chat/chat_t",
    type: "post",
    data
  });
}
